import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { CircularProgress } from "@mui/material"

const RunGroupDialog = ({
  open,
  isSubmitting,
  formId,
  onClose,
  children,
}: {
  open: boolean
  isSubmitting: boolean
  formId: string
  onClose: () => void
  children: React.ReactNode
}) => {
  const handleClose = () => onClose()

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Run your scenario</DialogTitle>
      <DialogContent sx={{ minWidth: 500, borderRadius: "30px" }}>{children}</DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"contained"}>
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          type="submit"
          form={formId}
          disabled={isSubmitting}
          startIcon={isSubmitting && <CircularProgress size={14} />}
        >
          Run
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RunGroupDialog
